import { api_GET, api_POST, api_PUT, api_POST_Unauthorize } from "api/_axios.js";

const relatorio_api =
{
    getApuracaoDreMensal: function (mesano) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Relatorio/GetApuracaoDreMensal/${mesano}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getApuracaoDreMensalGE: function (parametros) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorio/GetApuracaoDreMensalGE/`, parametros).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getApuracaoDreMensalLoja: function (parametros) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorio/GetApuracaoDreMensalLoja/`, parametros).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getDatasProcessadas: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Relatorio/GetDataProcessada/`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getPendenciasAcumuladasDetalhado: function (parametro) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Relatorio/GetRelPendenciasAcumuladasDetalhado/${parametro}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getPendenciasAcumuladasConsolidado: function (parametro) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Relatorio/GetRelPendenciasAcumuladasConsolidado/${parametro}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getLogsAlteracaoDre: function (parametros) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Relatorio/GetLogsAlteracaoDre/`, parametros).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default relatorio_api
